var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
(() => {
    angular.module('QMC.Termin', ['QMC.Fachleistung']).config(routes);
    ;
    routes.$inject = ['$locationProvider', '$stateProvider', '$urlRouterProvider', 'qmcBase'];
    function routes($locationProvider, $stateProvider, $urlRouterProvider, qmcBase) {
        $locationProvider.html5Mode({
            enabled: false,
            requireBase: false
        });
        $stateProvider
            .state('appointment', {
            url: '/appointment?:startDay?view',
            templateUrl: qmcBase + '/termin',
            controller: 'TerminListController',
            controllerAs: 'vm',
            resolve: {
                data: [() => {
                        console.log('Current State: Appointment List');
                    }]
            },
            params: {
                startDay: {
                    dynamic: true
                },
                view: {
                    dynamic: true
                }
            }
        })
            .state('appointment.detail', {
            url: '/appointment/:id/:isRecurring/:participantId/:dateFrom/:start/:end/:wholeSerie/:permFlag',
            templateUrl: qmcBase + '/termin/detail',
            controller: 'TerminDetailController',
            controllerAs: 'vm',
            resolve: {
                data: [() => {
                        console.log('Current State: Appointment Detail');
                    }]
            }
        })
            .state('appointment.detailshort', {
            url: '/appointment/:id',
            templateUrl: qmcBase + '/termin/detail',
            controller: 'TerminDetailController',
            controllerAs: 'vm',
            resolve: {
                data: [() => {
                        console.log('Current State: Appointment Detail SHORT');
                    }]
            }
        });
    }
})();
var QMC;
(function (QMC) {
    var Termin;
    (function (Termin) {
        class HttpProvider {
            static configureHttpProvider($httpProvider) {
                // initialize get if not there
                if (!$httpProvider.defaults.headers.get) {
                    $httpProvider.defaults.headers.get = {};
                }
                // disable IE ajax request caching
                $httpProvider.defaults.headers.get['If-Modified-Since'] = 'Mon, 26 Jul 1997 05:00:00 GMT';
                // extra
                $httpProvider.defaults.headers.get['Cache-Control'] = 'no-cache';
                $httpProvider.defaults.headers.get['Pragma'] = 'no-cache';
            }
        }
        Termin.HttpProvider = HttpProvider;
    })(Termin = QMC.Termin || (QMC.Termin = {}));
})(QMC || (QMC = {}));
(() => {
    angular.module('QMC.Termin')
        .config(['$httpProvider', QMC.Termin.HttpProvider.configureHttpProvider]);
})();
var QMC;
(function (QMC) {
    var Termin;
    (function (Termin) {
        let TerminService = class TerminService extends QMC.Common.BaseService {
            constructor($http, $q) {
                super($http, $q);
                this.$http = $http;
                this.$q = $q;
                this.modulePath = '/Appointment';
            }
            getCalendarList() {
                return super.get(this.modulePath + '/Calendar', {}, (data) => {
                    return data;
                });
            }
            getAppointmentTypes() {
                return super.get(this.modulePath + '/Type', {}, (data) => {
                    return data;
                });
            }
            getAppointmentList(personObjectId, dateFrom, dateTo, appointmentTypes, getOrganisation = false) {
                return super.getItem(this.modulePath, { personObjectId: personObjectId, dateFrom: dateFrom, dateTo: dateTo, appointmentTypes: appointmentTypes, getOrganisation }, (data) => {
                    this.displayNotifications(data.errors, "Hinweis", "warning", "qm-icon-information");
                    return data.items;
                });
            }
            //getAppointment(id: Guid, isRecurring: boolean, participantId: Guid, dateFrom: any): any {
            //    return super.get(this.modulePath + '/' + id + '/' + isRecurring + '/' + participantId + '/' + moment(dateFrom).format('YYYY-MM-DD'), {}, (data: IAppointment[]) => {
            //        return data;
            //    });
            //}
            getAppointment(id, participantId, dateFrom, wholeSerie, permFlag) {
                return super.get(this.modulePath + '/' + id, { participantId: participantId, dateFrom: moment(dateFrom).format('YYYY-MM-DD'), wholeSerie: wholeSerie, permFlag: permFlag }, (data) => {
                    return data;
                });
            }
            getAppointmentWv() {
                return super.getItem(this.modulePath + '/WvModel', {}, (data) => {
                    return data;
                });
            }
            postAppointment(data) {
                return super.post(this.modulePath, data).then((d) => {
                    return d;
                });
            }
            putAppointment(id, isRecurring, participantId, dateFrom, wholeSeries, data, changeRecurrenceDay = false) {
                return super.put(this.modulePath + '/' + id + '/' + isRecurring + '/' + participantId + '/' + moment(dateFrom).format('YYYY-MM-DD') + '/' + wholeSeries + `?changeRecurrenceDay=${changeRecurrenceDay}`, data).then((d) => {
                    return d;
                });
            }
            deleteAppointment(id, isRecurring, participantId, dateFrom, wholeSeries, allParticipants) {
                return super.delete(this.modulePath + '/' + id + '/' + isRecurring + '/' + participantId + '/' + moment(dateFrom).format('YYYY-MM-DD') + '/' + wholeSeries + '/' + allParticipants).then((e) => {
                    return e;
                });
            }
            validateAppointment(request) {
                return super.post(this.modulePath + '/validation', request).then(data => {
                    return data;
                });
            }
            getHolidays(year) {
                return super.get(this.modulePath + '/holiday', { year: year }, (data) => {
                    return data;
                });
            }
            getHolidaysSpecific(year, getHolidayDays, getVacationDays) {
                return super.get(this.modulePath + '/holiday', { year: year, getHolidayDays: getHolidayDays, getVacationDays: getVacationDays }, (data) => {
                    return data;
                });
            }
            getShareablePersonList() {
                return super.get(this.modulePath + '/Calendar/ShareablePerson', {}, (data) => {
                    return data;
                });
            }
            getAccessibleCalenderList(objectType) {
                return super.get(this.modulePath + '/Calendar/Accessible', { objectType: objectType }, (data) => {
                    return data;
                });
            }
            getCalendarTypeList() {
                return super.get(this.modulePath + '/Calendar/Type', {}, (data) => {
                    return data;
                });
            }
            putAccessible(list) {
                return super.put(this.modulePath + '/Calendar/Accessible/SetAllocationStates', list).then((data) => {
                    return data;
                });
            }
            putShareOwnCalendar(list) {
                return super.put(this.modulePath + '/Calendar/ShareOwnCalendarWithPersons', list).then((data) => {
                    return data;
                });
            }
        };
        TerminService = __decorate([
            QMC.Service('QMC.Termin', 'TerminService'),
            QMC.Inject('$http', '$q')
        ], TerminService);
        Termin.TerminService = TerminService;
    })(Termin = QMC.Termin || (QMC.Termin = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Termin;
    (function (Termin) {
        class UserInterface extends QMC.Common.UserInterface {
            constructor() {
                super();
                this.appointmentForm = {
                    form: [
                        {
                            label: "Betreff",
                            placeholder: "",
                            type: "String",
                            model: "title",
                            required: true,
                            lngTag: "20018006",
                            validate: {
                                message: "Bitte den Betreff angeben.",
                                messageTag: "20018024"
                            },
                            style: {
                                class: "col-xs-12",
                                icon: "fa fa-font"
                            }
                        },
                        {
                            label: "Teilnehmer",
                            type: "Select2",
                            model: "participantIds",
                            id: "selectedClientIds",
                            dataSource: "getParticipants",
                            lngTag: "20018007",
                            multiple: true,
                            required: true,
                            validate: {
                                message: "Bitte einen Teilnehmer auswählen."
                            },
                            style: {
                                class: "col-xs-12"
                            }
                        },
                        {
                            type: "hr"
                        },
                        {
                            type: "DateRange",
                            requiredTo: true,
                            model: {
                                dateFrom: "dateFrom",
                                dateTo: "dateTo"
                            },
                            label: {
                                dateFrom: "Datum von",
                                dateTo: "Datum bis"
                            },
                            lngTag: {
                                dateFrom: "20000047",
                                dateTo: "20000054"
                            },
                            style: {
                                class: "col-xs-12"
                            },
                            config: {
                                displayTime: true,
                                displayDateTo: true,
                                disableDate: false,
                                disableTime: "isAllDay",
                                dateToRequired: true
                            },
                            events: {
                                hideExpression: "(qmForm.recuringType > 0 && !qmForm.disableRecurring)"
                            }
                        },
                        {
                            type: "DateRange",
                            model: {
                                dateFrom: "dateFrom",
                                dateTo: "dateTo"
                            },
                            label: {
                                dateFrom: "Wiederholen ab"
                            },
                            lngTag: {
                                dateFrom: "20018540"
                            },
                            style: {
                                class: "col-xs-12"
                            },
                            config: {
                                displayTime: true,
                                disableTime: false,
                                displayDateTo: false,
                                dateToRequired: false,
                                disableDate: false
                            },
                            events: {
                                hideExpression: "((qmForm.recuringType == 0 || qmForm.recuringType == null) || (qmForm.disableRecurring))"
                            }
                        },
                        {
                            label: "Ort",
                            placeholder: "Ort angeben",
                            placeholderTag: "20003004",
                            type: "String",
                            lngTag: "20003004",
                            model: "location",
                            style: {
                                class: "col-md-6 col-xs-12",
                                icon: "fa fa-map-marker"
                            },
                        },
                        {
                            label: "Wiederholung",
                            type: "Select",
                            model: "recuringType",
                            id: "recuringType",
                            dataSource: "getRecurringTypes",
                            disabled: "disableRecurring",
                            lngTag: '20018052',
                            style: {
                                class: "col-md-3 col-xs-12"
                            }
                        },
                        {
                            label: "Wiederholen bis",
                            id: "recurringEndDate",
                            placeholder: "Wiederholen bis",
                            placeholderTag: "20018053",
                            type: "Date",
                            model: "rangeDateTo",
                            lngTag: '20018053',
                            startDate: new Date(),
                            disabled: "disableRecurringEndDate",
                            style: {
                                icon: "fa fa-font",
                                class: "col-md-3 col-xs-12"
                            }
                        },
                        {
                            label: "Bemerkung",
                            placeholder: "Bemerkung eingeben ...",
                            placeholderTag: "20000049",
                            type: "Textarea",
                            maxLength: -1,
                            lngTag: "20000049",
                            model: "description",
                            style: {
                                icon: "qm-icon-note_text",
                                class: "colm-md-6 col-xs-12"
                            }
                        },
                        {
                            label: "Privat",
                            type: "Checkbox",
                            model: "isPrivate",
                            lngTag: "20018014",
                            style: {
                                class: "col-md-4 col-xs-12"
                            }
                        },
                        {
                            label: "Erledigt",
                            type: "Checkbox",
                            model: "isFinished",
                            lngTag: "20000120",
                            style: {
                                class: "col-md-4 col-xs-12"
                            }
                        },
                        {
                            label: "Ganztägig",
                            type: "Checkbox",
                            model: "isAllDay",
                            lngTag: "20018016",
                            style: {
                                class: "col-md-4 col-xs-12"
                            }
                        },
                        {
                            label: "Erinnerung Aktiv",
                            type: "Checkbox",
                            model: "reminder",
                            lngTag: "20018530",
                            style: {
                                class: "col-xs-12 col-md-2"
                            }
                        },
                        {
                            label: "Anzahl",
                            lngTag: "20000123",
                            type: "Number",
                            model: "reminderAmount",
                            style: {
                                class: "col-xs-4 col-md-4"
                            },
                            events: {
                                hideExpression: "!(qmForm.reminder)"
                            }
                        },
                        {
                            label: "Einheit",
                            type: "Select",
                            model: "reminderUnit",
                            dataSource: "getReminderUnits",
                            lngTag: '20000096',
                            style: {
                                class: "col-md-6 col-xs-8"
                            },
                            events: {
                                hideExpression: "!(qmForm.reminder)"
                            }
                        }
                    ],
                    actions: {
                        put: "putAppointment",
                        post: "addAppointment",
                        delete: "deleteAppointment"
                    }
                };
            }
            /**
             * return the device default view
             *
             * @public
             * @returns {string}
             *
             * @memberOf TerminListController
             */
            deviceDefault() {
                if (localStorage.getItem('calendarView') !== null)
                    return localStorage.getItem('calendarView');
                if (QMC.Common.Constants.IS_MOBILE)
                    return 'agendaDay';
                return 'agendaWeek';
            }
            formatListDates() {
                $('.fc-list-heading').each(function (index) {
                    $(this).find(".fc-list-heading-alt").text(moment($(this).attr('data-date')).format('DD.MM.YYYY'));
                });
                $('.fc-list-item').each(function (index) {
                    var time = $(this).find(".fc-list-item-time").text();
                    if (time === "Ganztägig")
                        return;
                    if (time.split('-')[1] !== undefined)
                        time = moment(time.split(" - ")[0], 'h:mma').format('HH:mm') + ' - ' + moment(time.split(" - ")[1], 'h:mma').format('HH:mm');
                    else
                        time = moment(time, 'h:mma').format('HH:mm');
                    $(this).find(".fc-list-item-time").text(time);
                });
            }
            detailLink(event, wholeSerie /* if the event is recurring the user is asked if he/she wants to edit only the event clicked or the whole event*/) {
                if (event.appointmentType !== 401000)
                    return "#/appointment";
                return "#/appointment/appointment/" +
                    (event.isRecurring ? event.mid : event.objectId) + "/" +
                    event.isRecurring + "/" + event.participantObjectId + "/" +
                    event.dateFrom + "/" +
                    ((event.start) ? moment(event.start._d).toISOString() : 0) + "/" +
                    ((event.end) ? moment(event.end._d).toISOString() : ((event.start !== undefined) ? moment(event.start._d).toISOString() : 0)) +
                    "/" + wholeSerie + "/" + event.permFlag;
            }
        }
        Termin.UserInterface = UserInterface;
    })(Termin = QMC.Termin || (QMC.Termin = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Termin;
    (function (Termin) {
        let TerminListController = class TerminListController {
            /**
             * Creates an instance of TerminListController.
             * @param {TerminService} terminService
             * @param {any} $qui
             * @param {Fachleistung.FlsService} flsService
             * @param {Klient.KlientService} clientService
             * @param {any} $state
             * @param {any} $scope
             * @param {Common.QmcLanguageService} lng
             * @param {StammdatenService} stammdatenService
             *
             * @memberOf TerminListController
             */
            constructor(terminService, $qui, flsService, clientService, $state, $scope, $timeout, lng, userService, $location, permissionService, $stateParams, taskService, stammdatenService) {
                this.terminService = terminService;
                this.$qui = $qui;
                this.clientService = clientService;
                this.$state = $state;
                this.$scope = $scope;
                this.$timeout = $timeout;
                this.lng = lng;
                this.userService = userService;
                this.permissionService = permissionService;
                this.$stateParams = $stateParams;
                this.taskService = taskService;
                this.stammdatenService = stammdatenService;
                this.filterText = '';
                this.ui = new Termin.UserInterface();
                this.reccuring = new Termin.RecurringOptions();
                this.calendarList = [];
                this.calendarList2 = [];
                this.shareablePersonListChanges = [];
                this.selectedCalendarType = 120000;
                this.formState = 'new';
                this.requestLock = false;
                this.disableCheckboxes = false;
                this.appointmentTypesToShow = [
                    401000,
                    401010 // Planned fls
                ];
                this.holidayUserSettings = [];
                this.eventCache = [];
                this.selectedTypes = true;
                this.promptOptionsTask = {
                    title: '',
                    icon: 'qm-icon-clipboard_check_edit',
                    yesNo: true,
                    id: 'promptTask',
                    text: this.lng.translate(20014023, 'Wollen Sie diese Aufgabe als erledigt makieren?')
                };
                this.promptChangeRecurringTerminDate = {
                    title: '',
                    icon: 'qm-icon-clipboard_check_edit',
                    yesNo: true,
                    id: 'promptChangeRecurringDate',
                    text: this.lng.translate(20018539, 'Wenn Sie alle Datumsangaben ändern möchten, öffnen Sie die Terminserie. Möchten Sie die ganze Serie bearbeiten?')
                };
                this.isGettingData = false;
                this.isWidget = false;
                this.appointmentObjectPermissions = {
                    delete: false,
                    modify: false,
                    new: false
                };
                this.lastRequest = {};
                this.slotDuration = 30;
                this.calendarName = 'calendar';
                /**
                 * get list of specific reccuring types
                 *
                 * @private
                 *
                 * @memberOf TerminListController
                 */
                this.getRecurringTypes = () => { return this.reccuring.reccuringSelectList; };
                this.getReminderUnits = () => { return this.reminderUnits; };
                /**
                 * get the personal calendar
                 *
                 * @private
                 *
                 * @memberOf TerminListController
                 */
                this.firstLoad = true;
                this.dblClick = null;
                this.clickTimer = null;
                if (document.getElementById("permissions").getAttribute("appointment").toLocaleLowerCase() !== "true") {
                    console.log("No rights to see module appointment");
                    this.forbidden = true;
                    return;
                }
                $(`#${this.calendarName}`).fullCalendar('removeEvents');
                $(`#${this.calendarName}`).fullCalendar('removeEventSources');
                this.isWidget = false;
                this.mobile = this.ui.isMobile();
                this.initForm();
                this.getCalendarList();
                this.getShareablePersonList();
                this.getCalenderTypeList();
                this.getAccessibleCalendarList(this.selectedCalendarType);
                this.$timeout = $timeout;
                this.reminderUnits = [
                    { value: 0, text: this.lng.translate(20000247, 'Minuten') },
                    { value: 1, text: this.lng.translate(20000219, 'Stunden') },
                    { value: 2, text: this.lng.translate(20000245, 'Tage') },
                    { value: 3, text: this.lng.translate(20000246, 'Monate') }
                ];
                this.promptOptions = {
                    title: this.lng.translate(20018050, "Serientermin"),
                    icon: "qm-icon-calendar_7",
                    id: "prompt-change",
                    fields: [
                        {
                            text: this.lng.translate(20018051, 'Wollen Sie diesen Termin oder die ganze Serie bearbeiten?'), name: 'wholeSeries',
                            options: [{ text: this.lng.translate(20018044, "Dieser Termin"), value: false }, { text: this.lng.translate(20018045, "Alle Termine dieser Serie"), value: true }]
                        }
                    ]
                };
                const storageObject = QMC.Common.personalLocalStorage.getItem(QMC.Common.LocalStorageConstants.APPOINTMENT_TYPES_TO_SHOW);
                if (storageObject && storageObject !== "")
                    this.appointmentTypesToShow = storageObject.split(",").map(Number);
                flsService.getCasesList().then((data) => {
                    this.cases = data;
                    this.caseList = $qui.select(data, { value: 'internalName', text: 'internalName' });
                    this.resetData();
                });
                this.$scope.$watch('vm.form.recuringType', () => {
                    if (this.form.recuringType > 0 && this.form.recuringType !== null && this.form.disableRecurring === false) {
                        this.form.disableRecurringEndDate = false;
                        this.form.rangeDateFrom = this.form.dateFrom;
                        this.form.rangeDateTo = this.form.dateTo;
                        this.form.isRecurring = true;
                    }
                    else {
                        this.form.disableRecurringEndDate = true;
                        this.form.isRecurring = this.form.recuringType !== null;
                        this.form.rangeDateTo = null;
                    }
                });
                this.userService.getUserSettings(['TERMINPLAN.FERIEN.VISIBLE', 'TERMINPLAN.FEIERTAGE.VISIBLE', 'WEBCLIENT.CALENDAR.SLOTDURATION'], false).then((settings) => {
                    this.slotDuration = settings[2].value && settings[2].value.length > 0 ? parseInt(settings[2].value) : this.slotDuration;
                    this.holidayUserSettings = settings;
                    this.terminService.getAppointmentTypes().then((data) => {
                        for (const type in data)
                            data[type].state = this.appointmentTypesToShow.indexOf(data[type].typeId) >= 0;
                        const ferien = {
                            typeId: 1,
                            name: this.lng.translate(20000229, 'Feiertage'),
                            colorHtml: '#DBDBDB',
                            state: this.holidayUserSettings[0].value === "true",
                        };
                        const feiertage = {
                            typeId: 2,
                            name: this.lng.translate(20000230, 'Ferien'),
                            colorHtml: '#DBDBDB',
                            state: this.holidayUserSettings[1].value === "true",
                        };
                        data.push(feiertage);
                        data.push(ferien);
                        data.sort((a, b) => (a.name.toLocaleLowerCase() > b.name.toLocaleLowerCase()) ? 1 : ((b.name.toLocaleLowerCase() > a.name.toLocaleLowerCase()) ? -1 : 0));
                        this.appointmentTypes = data;
                    });
                    this.permissionService.getPermissionsByObjectType(400000).then((data) => {
                        this.appointmentObjectPermissions = {
                            new: data[0].new,
                            modify: data[0].new,
                            delete: data[0].delete,
                        };
                    });
                });
                $qui.init($qui.getSectionColor($location.path()), () => {
                    this.render();
                    $qui.anonAvatar();
                    $qui.bindEvents();
                });
                this.clientService.getPersonListByObjectTypes([120000, 130000, 140000, 140006], '', true, false).then((data) => {
                    data.map(item => {
                        item.displayTitle = this.$qui.createPersonDisplay(item.displayTitle, '', item.shortCaption, item.personNumber);
                        return item;
                    });
                    this.clientService.getAllPersonLists().then((dataPL) => {
                        this.clientService.getResourceList('', true).then((dataRes) => {
                            this.clientService.getVehicleList().then((dataVeh) => {
                                let temp = data.map((x) => ({ text: x.displayTitle, value: x.objectId, group: this.getGroupName(x.objectType), subText: x.institute }));
                                temp = temp.concat(dataPL.map((x) => ({ text: x.name, value: x.objectId, group: this.lng.translate(20000237, 'Personenliste'), subText: '' })));
                                temp = temp.concat(dataRes.map((x) => ({ text: x.caption, value: x.objectId, group: this.lng.translate(20000271, 'Ressource'), subText: x.institute })));
                                temp = temp.concat(dataVeh.map((x) => ({ text: x.displayTitle, value: x.objectId, group: this.lng.translate(20029006, 'Fuhrpark'), subText: x.kindOfVehicle })));
                                temp.sort((a, b) => (a.text.toLocaleLowerCase() > b.text.toLocaleLowerCase()) ? 1 : ((b.text.toLocaleLowerCase() > a.text.toLocaleLowerCase()) ? -1 : 0));
                                temp.sort((a, b) => (a.group.toLocaleLowerCase() > b.group.toLocaleLowerCase()) ? 1 : ((b.group.toLocaleLowerCase() > a.group.toLocaleLowerCase()) ? -1 : 0));
                                this.participants = temp;
                                this.$qui.functionWaiter("ui.createForm", this);
                            });
                        });
                        //get the organisation for the logged user
                        this.stammdatenService.getOrganisationForPerson($('#session').data().personId).then((data) => {
                            this.organisationForCurrentUser = data.organisationId;
                        });
                    });
                });
                this.$scope.$watch('vm.$state.current.name', (newVal, oldVal) => {
                    if (newVal !== oldVal && newVal === 'appointment')
                        this.resetData(true);
                });
            }
            getParticipants() {
                return this.participants;
            }
            getGroupName(type) {
                switch (type) {
                    case 120000:
                        return this.lng.translate(20000235, 'Mitarbeiter');
                    case 130000:
                        return this.lng.translate(20000279, 'Organisation');
                    case 140000:
                        return this.lng.translate(21002000, 'Klient');
                    case 140006:
                        return this.lng.translate(20001048, 'Kontaktperson');
                    default:
                        return '';
                }
            }
            /**
             * convert to title case
             *
             * @private
             * @param {string} str
             * @returns {string}
             *
             * @memberOf TerminListController
             */
            toTitleCase(str) {
                return str.replace(/\w\S*/g, txt => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase());
            }
            /**
             * init the form with default values
             *
             * @private
             *
             * @memberOf TerminListController
             */
            initForm() {
                this.form = {
                    title: null,
                    dateFrom: moment(new Date()).startOf('hour').add(1, "hour").toDate(),
                    dateTo: moment(new Date()).startOf('hour').add(1, "hour").add(30, 'minutes').toDate(),
                    rangeDateFrom: new Date(),
                    rangeDateTo: null,
                    isAllDay: false,
                    location: null,
                    participantIds: !this.getForOrga ? [$('#session').data().personId] : [this.organisationForCurrentUser],
                    description: null,
                    isFinished: false,
                    isPrivate: false,
                    isRecurring: false,
                    recuringType: 0,
                    reminder: true,
                    reminderAmount: 15,
                    reminderUnit: 0,
                    disableRecurring: false,
                    disableRecurringEndDate: false,
                };
            }
            /**
             * get the calendar list
             *
             * @private
             *
             * @memberOf TerminListController
             */
            getCalendarList() {
                this.lastRequest = {};
                this.terminService.getCalendarList().then((data) => {
                    this.sharedCalendar = data;
                    this.sharedCalendarMap = data.map(x => ({ text: x.description, value: x.personObjectId }));
                    this.sharedCalendarMap.sort(function (x, y) {
                        const a = x.text.toUpperCase(), b = y.text.toUpperCase();
                        if (a > b) {
                            return 1;
                        }
                        if (a < b) {
                            return -1;
                        }
                        return 0;
                    });
                    if (!data.map(x => x.personObjectId).includes(this.selectedCalendar))
                        this.selectedCalendar = undefined;
                    if (this.selectedCalendar === (null || undefined)) {
                        this.selectedCalendar = data[0].personObjectId;
                        for (let i = 0; i < data.length; i++)
                            if (data[i].personObjectId === $('#session').data().personId)
                                this.selectedCalendar = data[i].personObjectId;
                    }
                    this.calendar = data[0];
                });
            }
            getDateList(id, dateFrom, dateTo, force = false) {
                const currentRequest = { id, dateFrom, dateTo, types: this.appointmentTypesToShow };
                if (!force && this.isGettingData || JSON.stringify(this.lastRequest) === JSON.stringify(currentRequest))
                    return;
                this.lastRequest = currentRequest;
                this.calendarList = [];
                $(`#${this.calendarName}`).fullCalendar('removeEvents');
                $(`#${this.calendarName}`).fullCalendar('removeEventSource', this.calendarList);
                $(`#${this.calendarName}`).fullCalendar('removeEventSources');
                this.isGettingData = true;
                this.loading = true;
                if (this.isWidget) {
                    this.userService.getUserSettings(['APPOINTMENT.WIDGET.ORGA', 'APPOINTMENT.WIDGET.DAYSTOPAST', 'APPOINTMENT.WIDGET.DAYSTOFUTURE']).then((data) => {
                        this.getForOrga = data[0].value.toLowerCase() === 'true';
                        const daysToPast = data[1].value.length > 0 ? parseInt(data[1].value) : 0;
                        const daysToFuture = data[2].value.length > 0 && parseInt(data[2].value) > 0 ? parseInt(data[2].value) : 7 - moment().isoWeekday();
                        this.viewDateFrom = moment().startOf('day').add(-daysToPast, 'd').toDate();
                        this.viewDateTo = moment().endOf('day').add(daysToFuture, 'd').toDate();
                        this.getData(id, this.viewDateFrom, this.viewDateTo, this.getForOrga);
                    });
                }
                else {
                    this.$timeout(() => {
                        this.getData(id, dateFrom, dateTo, this.getForOrga);
                    });
                }
            }
            getData(id, dateFrom, dateTo, getOrga = false) {
                this.terminService.getAppointmentList(id, dateFrom, dateTo, this.appointmentTypesToShow, getOrga).then((data) => {
                    //Feiertage
                    this.terminService.getHolidaysSpecific(this.calculateCurrentYearOfCalender(dateFrom, dateTo), this.appointmentTypesToShow.some(x => x === 2), this.appointmentTypesToShow.some(x => x === 1)).then((holidays) => {
                        this.$qui.functionWaiter("ui.createForm", this);
                        this.isGettingData = false;
                        this.loading = false;
                        for (let i = 0; i < holidays.length; i++) {
                            holidays[i].allDay = true;
                            holidays[i].title = holidays[i].caption;
                            holidays[i].editable = false;
                            holidays[i].color = "#DBDBDB";
                            holidays[i].start = moment(holidays[i].dateFrom);
                            holidays[i].end = moment(holidays[i].dateTo);
                            this.calendarList.push(holidays[i]);
                        }
                        this.eventCache = [];
                        if (data[0] !== undefined)
                            if (data[0].objectId.toString().length > 1) {
                                for (let i = 0; i < data.length; i++) {
                                    this.calendarList.push(this.ui.createCalendarEvent(data[i], (data[i].appointmentTypeId === 840501 ||
                                        data[i].appointmentTypeId === 411010 ||
                                        data[i].appointmentTypeId === 401000) ? null : this.$qui.generateGuid(), this.appointmentTypes));
                                }
                                this.eventCache = angular.copy(this.calendarList);
                            }
                        $(`#${this.calendarName}`).fullCalendar('addEventSource', this.calendarList);
                        this.loading = false;
                        if (this.isWidget)
                            this.widgetRender(this.calendarList);
                        else
                            this.setupCalendar();
                    });
                });
            }
            resetCalendar() {
                $(`#${this.calendarName}`).fullCalendar('removeEvents');
                $(`#${this.calendarName}`).fullCalendar('removeEventSource', this.calendarList);
                $(`#${this.calendarName}`).fullCalendar('removeEventSources');
                $(`#${this.calendarName}`).fullCalendar('addEventSource', this.calendarList);
                $(`#${this.calendarName}`).fullCalendar('refetchEvents');
                $(`#${this.calendarName}`).fullCalendar('rerenderEvents');
            }
            calculateCurrentYearOfCalender(dateFrom, dateTo) {
                const To = this.$qui.createDateFromString(dateTo);
                const From = this.$qui.createDateFromString(dateFrom);
                const year = (To.getMonth() - From.getMonth() >= 0) ? To.getFullYear() : From.getFullYear();
                return year;
            }
            /**
             * Rendering of the Widget Calendar
             *
             * @returns
             *
             * @memberof TerminListController
             */
            widgetRender(calEvents) {
                return null;
            }
            /**
             * add an array of events to personal calendar
             *
             * @private
             * @param {*} arr
             *
             * @memberOf TerminListController
             */
            addToPersonalCalendar(arr) {
                $(`#${this.calendarName}`).fullCalendar('removeEvents');
                this.calendarList2 = [];
                setTimeout(() => {
                    this.terminService.getAppointmentList(arr.personObjectId, this.form.dateFrom, this.form.dateTo, this.appointmentTypesToShow).then((data) => {
                        for (let i = 0; i < data.length; i++) {
                            if (data[0].objectId.toString().length > 1) {
                                this.calendarList2.push(this.ui.createCalendarEvent(data[i]));
                            }
                        }
                        $(`#${this.calendarName}`).fullCalendar('addEventSource', this.calendarList2);
                        this.setupCalendar();
                    });
                }, 500);
            }
            /**
             * add a new appointment
             *
             * @private
             * @param {*} form is modified IAppointmentCreate, to inject participants!
             *
             * @memberOf TerminListController
             */
            addAppointment(form) {
                if (form.recuringType > 0) {
                    form.isRecurring = true;
                    form.recurrenceOptions = this.reccuring.getOptions(Number(form.recuringType), form.dateFrom);
                    form.recurrenceOptions.rangeDateFrom = form.dateFrom;
                    this.reccuring.setRangeLimit(0);
                    if (form.rangeDateTo !== null) {
                        form.recurrenceOptions.rangeDateTo = form.rangeDateTo;
                        this.reccuring.setRangeLimit(2);
                    }
                }
                this.validateAppointment(form);
                this.validationCallback = (form) => {
                    $('#edit-form').modal('hide');
                    this.terminService.postAppointment(form).then(() => {
                        console.log("Form", form);
                        this.ui.notify(this.ui.successNote);
                        this.formState = 'new';
                        this.resetData();
                    });
                };
            }
            /**
             * when a event on the fullcalendar has changed
             *
             * @private
             * @param {any} id
             * @param {any} data
             *
             * @memberOf TerminListController
             */
            changeEvents(id, isRecurring, participantId, dateFrom, data) {
                if (isRecurring) {
                    QMC.Common.Utilities.confirm(this.promptOptions, (prompt) => {
                        if (prompt)
                            this.modifyEvents(id, isRecurring, participantId, dateFrom, data, prompt.wholeSeries);
                        else
                            this.resetCalendar();
                    }, '#prompto');
                }
                else {
                    this.modifyEvents(id, isRecurring, participantId, dateFrom, data);
                }
            }
            modifyEvents(id, isRecurring, participantId, dateFrom, data, wholeSeries = false) {
                if (id !== undefined) {
                    this.loading = true;
                    if (!(data.permissions.modify)) {
                        this.$qui.notify({
                            message: this.lng.translate(20002034, "Keine Berechtigung für diesen Datensatz."),
                            title: "Fehler",
                            icon: "qm-icon-error",
                            status: "warning",
                            timer: 3500
                        });
                        this.resetData();
                        return;
                    }
                    if (data.dateTo === null)
                        data.dateTo = data.dateFrom;
                    data.dateFrom = moment(data.dateFrom).toDate();
                    data.dateTo = moment(data.dateTo).toDate();
                    data.mainAppointmentId = id;
                    data.participantIds = [participantId];
                    data.changeDatesOnly = true;
                    this.validateAppointment(data);
                    this.validationCallback = () => {
                        this.terminService.putAppointment(id, isRecurring, participantId, dateFrom, wholeSeries, data, isRecurring && this.dayChanged(id, data.dateFrom)).then(() => {
                            this.$qui.notify(this.$qui.successNote);
                            this.resetData();
                        });
                    };
                }
            }
            getOriginalDate(id, getDateFrom = true) {
                for (const event of this.eventCache) {
                    if (event.objectId === id) {
                        return getDateFrom ? moment(event.start) : moment(event.end);
                    }
                }
                return null;
            }
            dayChanged(id, date) {
                for (const event of this.eventCache) {
                    if (event.objectId === id) {
                        return moment(event.dateFrom).isoWeekday() !== moment(date).isoWeekday();
                    }
                }
                return false;
            }
            getPersonalCalendar(view) {
                if (view !== null)
                    QMC.Common.personalLocalStorage.setItem('calendarView', view.name);
                this.setViewDates();
                //$(`#${this.calendarName}`).fullCalendar('removeEvents'); //Why was this here? removed for Q3W-232
                this.requestLock = true;
                this.terminService.getCalendarList().then((data) => {
                    if (!this.requestLock)
                        return;
                    this.requestLock = false;
                    if (data.length > 0) {
                        this.getDateList(this.selectedCalendar, this.viewDateFrom, this.viewDateTo);
                        if (this.personalCalendar === undefined)
                            this.personalCalendar = data;
                    }
                });
            }
            /**
             * reset the fullcalendar data, get new
             *
             * @public
             *
             * @memberOf TerminListController
             */
            resetData(force = false) {
                //this.calendarList = [];
                this.loading = true;
                this.lastRequest = {};
                this.getPersonalCalendar(null);
                this.getDateList(this.selectedCalendar, this.viewDateFrom, this.viewDateTo, force);
            }
            /**
             * render the fullcalendar
             *
             * @private
             *
             * @memberOf TerminListController
             */
            render() {
                this.$scope.$watch('vm.selectedCalendar', (oldVal, newVal) => {
                    if (oldVal !== newVal && oldVal !== undefined) {
                        this.resetData();
                        this.form.participantIds = [this.selectedCalendar];
                        if (this.selectedCalendar !== $('#session').data().personId) {
                            this.form.participantIds.push($('#session').data().personId);
                        }
                    }
                });
                this.$scope.$watch('vm.appointmentTypes', (oldVal, newVal) => {
                    if (oldVal !== newVal && oldVal !== undefined) {
                        this.disableCheckboxes = true;
                        setTimeout(() => { this.disableCheckboxes = false; }, 1000); //coldfix
                        this.appointmentTypesToShow = [];
                        for (const type in this.appointmentTypes) {
                            const currentType = this.appointmentTypes[type];
                            if (currentType.state) {
                                this.appointmentTypesToShow.push(currentType.typeId);
                            }
                            if (currentType.name === 'Ferien') {
                                this.userService.setUserSettings({ settings: [{ key: 'TERMINPLAN.FERIEN.VISIBLE', value: currentType.state }] }, false);
                            }
                            if (currentType.name === 'Feiertage') {
                                this.userService.setUserSettings({ settings: [{ key: 'TERMINPLAN.FEIERTAGE.VISIBLE', value: currentType.state }] }, false);
                            }
                        }
                        if (this.disableCheckboxes)
                            this.resetData();
                        console.log('#### appTypesToShow: ', this.appointmentTypesToShow);
                        //save selection in storage
                        if (this.appointmentTypesToShow.length > 0)
                            QMC.Common.personalLocalStorage.setItem(QMC.Common.LocalStorageConstants.APPOINTMENT_TYPES_TO_SHOW, this.appointmentTypesToShow.toString());
                    }
                }, true);
                setTimeout(() => {
                    $(`#${this.calendarName}`).fullCalendar('render');
                }, 500);
            }
            /**
             * get the height for the fullcalendar by device
             *
             * @private
             * @returns {number}
             *
             * @memberOf TerminListController
             */
            getHeight() {
                if ($('body').hasClass('mobile'))
                    return 350;
                return 650;
            }
            /**
             * set the view dates for the fullcalendar
             *
             * @private
             *
             * @memberOf TerminListController
             */
            setViewDates() {
                if (this.isWidget) {
                    return;
                }
                ;
                let dateFrom = $(`#${this.calendarName}`).fullCalendar('getView').start;
                let dateTo = $(`#${this.calendarName}`).fullCalendar('getView').end;
                if (typeof dateFrom !== "object")
                    dateFrom = new Date();
                if (typeof dateTo !== "object")
                    dateTo = new Date();
                this.viewDateFrom = moment(dateFrom).startOf('week').format();
                this.viewDateTo = moment(dateTo).endOf('week').add(1, 'day').format();
            }
            /**
    * Returns a qmc calendar event which can be shown in the calendar
    * @param appointment The appointment object
    */
            createCalendarEvent(appointment) {
                const event = {};
                event.id = appointment.objectId;
                event.objectId = appointment.objectId;
                event.mid = appointment.mainAppointmentId;
                event.title = appointment.title;
                event.start = moment(appointment.dateFrom);
                event.end = moment(appointment.dateTo);
                event.allDay = appointment.isAllDay;
                event.isFinished = appointment.isFinished;
                event.isPrivate = appointment.isPrivate;
                event.isRecurring = appointment.isRecurring;
                event.isTypeAppointment = appointment.isTypeAppointment;
                event.editable = true;
                event.color = appointment.colorHtml;
                event.iconCode = "";
                event.recurrenceSettings = appointment.recurrenceSettings;
                if (event.isFinished) {
                    event.iconCode += "<i class='fa fa-check'></i> ";
                }
                if (event.isPrivate) {
                    event.iconCode += "<i class='fa fa-lock'></i> ";
                }
                if (event.isRecurring) {
                    event.iconCode += "<i class='fa fa-refresh'></i> ";
                    event.editable = false;
                }
                if (event.isDeleted) {
                    event.iconCode += "<i class='fa fa-trash'></i> ";
                }
                if (!event.isTypeAppointment) {
                    event.editable = false;
                }
                return event;
            }
            getAppointmentObject(id) {
                for (let i = 0; i < this.calendarList.length; i++) {
                    const objAppointment = this.calendarList[i];
                    if (objAppointment.id === id) {
                        return objAppointment;
                    }
                }
                return null;
            }
            /**
             * configuration for the fullcalendar
             *
             * @private
             *
             * @memberOf TerminListController
             */
            setupCalendar() {
                var _a;
                const allDayText = this.lng.translate(20018016, "Ganztägig");
                // height was : "contentHeight: this.getHeight(),"
                $(`#${this.calendarName}`).fullCalendar({
                    schedulerLicenseKey: QMC.Common.Constants.FULL_CALENDAR_PREMIUM_LICENSE,
                    defaultTimedEventDuration: '00:30:00',
                    contentHeight: window.innerHeight - 250,
                    defaultView: (_a = this.$stateParams.view) !== null && _a !== void 0 ? _a : this.ui.deviceDefault(),
                    allDayText: allDayText,
                    timezone: "local",
                    allDaySlot: true,
                    slotLabelFormat: 'H:mm',
                    slotDuration: this.$qui.timeStringFromHours(this.slotDuration),
                    events: this.calendarList,
                    firstDay: 1,
                    monthNames: this.lng.translate(20018519, 'Januar,Februar,März,April,Mai,Juni,Juli,August,September,Oktober,November,Dezember').split(','),
                    monthNamesShort: this.lng.translate(20018520, 'Jan,Feb,Mrz,Apr,Mai,Jun,Jul,Aug,Sep,Okt,Nov,Dez').split(','),
                    dayNames: this.lng.translate(20018521, 'Sonntag,Montag,Dienstag,Mittwoch,Donnerstag,Freitag,Samstag').split(','),
                    dayNamesShort: this.lng.translate(20018522, 'So.,Mo.,Di.,Mi.,Do.,Fr.,Sa.').split(','),
                    weekNumbers: true,
                    weekNumberCalculation: (date) => { return moment(date).isoWeek(); },
                    nowIndicator: true,
                    views: {
                        month: {
                        //titleFormat: 'MMMM yyyy'
                        },
                        week: {
                            titleFormat: 'dddd, D MMM YYYY'
                        },
                        day: {
                            titleFormat: 'dddd D.MM'
                        }
                    },
                    buttonText: {
                        today: this.lng.translate(20000126, 'Heute'),
                        month: this.lng.translate(20000115, 'Monat'),
                        week: this.lng.translate(20000114, 'Woche'),
                        day: this.lng.translate(20000041, 'Tag')
                    },
                    viewRender: (view, element) => {
                        this.$state.go('.', {
                            startDay: this.$qui.createDateFromString($(`#${this.calendarName}`).fullCalendar('getView').start).toISOString(),
                            view: $(`#${this.calendarName}`).fullCalendar('getView').name
                        });
                        this.getPersonalCalendar(view);
                    },
                    columnFormat: 'ddd D.M',
                    timeFormat: 'H:mm',
                    header: {
                        left: 'prev,next today',
                        center: 'title',
                        right: 'month, agendaWeek, agendaDay'
                    },
                    editable: true,
                    droppable: true,
                    eventRender: (event, element) => {
                        $(element).find(".fc-title").prepend(event.iconCode);
                    },
                    eventResize: (event) => {
                        var _a;
                        const newForm = {
                            dateFrom: event.start,
                            dateTo: event.end,
                            title: event.title,
                            isAllDay: event.allDay,
                            changeDatesOnly: true,
                            permissions: (_a = event.permissions) !== null && _a !== void 0 ? _a : this.appointmentObjectPermissions
                        };
                        this.changeEvents(event.isRecurring ? event.mid : event.objectId, event.isRecurring, event.participantObjectId, event.start, newForm);
                    },
                    eventDrop: (event, detla, revert) => {
                        const objAppointment = this.getAppointmentObject(event.id);
                        const newForm = {
                            dateFrom: event.start,
                            dateTo: event.end,
                            title: event.title,
                            isAllDay: event.allDay,
                            changeDatesOnly: true,
                            recurrenceChangeDateFrom: this.getOriginalDate(event.isRecurring ? event.mid : event.objectId),
                            recurrenceChangeDateTo: this.getOriginalDate(event.isRecurring ? event.mid : event.objectId, false),
                            appointmentTypeId: this.appointment != null ? objAppointment.appointmentTypeId : event.appointmentType,
                            location: this.appointment != null ? objAppointment.location : event.location,
                            isTypeAppointment: this.appointment != null ? objAppointment.isTypeAppointment : event.isTypeAppointment,
                            isFinished: this.appointment != null ? objAppointment.isFinished : event.isFinished,
                            description: this.appointment != null ? objAppointment.description : event.description,
                            isPrivate: this.appointment != null ? objAppointment.isPrivate : event.isPrivate,
                            isManual: this.appointment != null ? objAppointment.isManual : event.isManual,
                            isRecurring: this.appointment != null ? objAppointment.isRecurring : event.isRecurring,
                            isDeleted: this.appointment != null ? objAppointment.isDeleted : event.isDeleted,
                            colorHtml: this.appointment != null ? objAppointment.colorHtml : event.color,
                            recurrenceSettings: this.appointment != null ? objAppointment.recurrenceSettings : event.recurrenceSettings,
                            permissions: event.permissions
                        };
                        if ((event.isRecurring && moment(event.start).format('YYYY-MM-DD') === event.dateFrom) || (!event.isRecurring)) {
                            this.calendarList = [];
                            this.changeEvents(event.isRecurring ? event.mid : event.objectId, event.isRecurring, event.participantObjectId, event.start, newForm);
                        }
                        else {
                            this.promptChangeRecurringTerminDate.title = event.title;
                            this.$qui.scopeApply(this.$scope);
                            QMC.Common.Utilities.confirm(this.promptChangeRecurringTerminDate, (result) => {
                                if (result) {
                                    location.hash = this.ui.detailLink(event, true);
                                }
                                else {
                                    this.resetCalendar();
                                }
                            }, '#promptChangeRecurringDate');
                        }
                    },
                    drop: () => {
                    },
                    aspectRatio: 5,
                    eventClick: (event) => {
                        if (event.appointmentType === 840501) {
                            if (event.isFinished)
                                this.$state.go("tasksdetail", { id: event.mainAppointmentId });
                            else {
                                this.promptOptionsTask.title = event.title;
                                this.$qui.scopeApply(this.$scope);
                                QMC.Common.Utilities.confirm(this.promptOptionsTask, (result) => {
                                    if (result) {
                                        this.taskService.setFinishedState(event.mainAppointmentId, true, moment().format('YYYY-MM-DD')).then(() => {
                                            this.$qui.notify(this.$qui.successNote);
                                            this.resetData();
                                        });
                                    }
                                    else {
                                        this.$state.go("tasksdetail", { id: event.mainAppointmentId });
                                    }
                                }, '#promptTask');
                            }
                        }
                        else if (event.appointmentType === 411010) {
                            QMC.Common.personalLocalStorage.setItem(QMC.Common.LocalStorageConstants.AZN_PREVIOUS_STATE, JSON.stringify({
                                state: this.$state.$current.name,
                                params: this.$state.$current.name
                            }));
                            this.$state.go('azndetail', { "id": event.id });
                        }
                        else if (event.appointmentType === 401008) {
                            $('#unsupportedAppointmentTypeModal').modal('show');
                        }
                        else if (event.editable) {
                            if (event.end === undefined || event.end === null)
                                event.end = event.start;
                            const path = this.ui.detailLink(event, !event.isRecurring);
                            if (event.isRecurring) {
                                this.promptOptions.title = event.title;
                                this.$qui.scopeApply(this.$scope);
                                QMC.Common.Utilities.confirm(this.promptOptions, (prompt) => {
                                    if (prompt) {
                                        if (location.hash !== path)
                                            location.hash = this.ui.detailLink(event, prompt.wholeSeries);
                                        else {
                                            location.hash = '#/appointment';
                                            setTimeout(() => {
                                                location.hash = this.ui.detailLink(event, prompt.wholeSeries);
                                            }, 500);
                                        }
                                    }
                                }, '#prompto');
                            }
                            else {
                                if (location.hash !== path)
                                    location.hash = this.ui.detailLink(event, false);
                                else {
                                    location.hash = '#/appointment';
                                    setTimeout(() => {
                                        location.hash = this.ui.detailLink(event, false);
                                    }, 500);
                                }
                            }
                        }
                    },
                    dayClick: (date, jsEvent, view) => {
                        const singleClick = moment(date).toISOString();
                        if (this.dblClick === singleClick) {
                            if (this.appointmentObjectPermissions.new) {
                                $("#edit-form").modal("toggle");
                                this.form.dateFrom = moment(date).toDate();
                                this.form.dateTo = moment(date).add('minutes', 30).toDate();
                                this.form.rangeDateFrom = moment(date).toDate();
                                this.form.disableRecurringEndDate = true;
                                this.$qui.scopeApply(this.$scope);
                            }
                            this.dblClick = null;
                        }
                        else {
                            this.dblClick = moment(date).toISOString();
                            clearInterval(this.clickTimer);
                            this.clickTimer = setInterval(function () {
                                this.dblClick = null;
                                clearInterval(this.clickTimer);
                            }, 500);
                        }
                        if (view.name === 'month') {
                            $(`#${this.calendarName}`).fullCalendar('gotoDate', date);
                            $(`#${this.calendarName}`).fullCalendar('changeView', 'agendaWeek');
                        }
                    }
                });
                if (this.firstLoad && !this.isWidget && this.$stateParams.startDay) {
                    this.firstLoad = false;
                    let dateMoment = moment(this.$stateParams.startDay);
                    if (this.$stateParams.view === 'month' && dateMoment.date() > 24)
                        dateMoment = dateMoment.add(1, 'month').startOf('month');
                    $(`#${this.calendarName}`).fullCalendar('gotoDate', dateMoment.toDate());
                }
            }
            getShareablePersonList() {
                this.terminService.getShareablePersonList().then((data) => {
                    this.shareablePersonList = data;
                });
            }
            getAccessibleCalendarList(selectedCalendarType) {
                this.loadingAccessibleCalendarList = true;
                this.terminService.getAccessibleCalenderList(selectedCalendarType).then((data) => {
                    this.accessibleCalendarList = data;
                    this.loadingAccessibleCalendarList = false;
                });
            }
            getCalenderTypeList() {
                this.terminService.getCalendarTypeList().then((data) => {
                    this.calendarTypeList = data;
                    this.calendarTypeListMap = this.$qui.selectAutoMap(data, 'objectType', 'caption');
                });
                this.$scope.$watch('vm.selectedCalendarType', (newVal, oldVal) => {
                    if (newVal === oldVal)
                        return;
                    this.calendarTypeChanged();
                });
            }
            calendarTypeChanged() {
                this.getAccessibleCalendarList(this.selectedCalendarType);
            }
            shareablePersonListItemChanged(changedItem) {
                this.shareablePersonListChanges.push(changedItem);
            }
            putAccessible() {
                $('#addCalenderModal').modal('hide');
                this.loadingAccessibleCalendarList = true;
                this.terminService.putAccessible(this.accessibleCalendarList).then(() => {
                    this.getAccessibleCalendarList(this.selectedCalendarType);
                    this.getCalendarList();
                    if (this.selectedCalendarType === 130000)
                        this.getDateList(this.selectedCalendar, this.viewDateFrom, this.viewDateTo);
                });
            }
            putShareOwnCalender(item) {
                $('#enableCalenderModal').modal('hide');
                //const list = this.shareablePersonListChanges.map((item) => { return { userId: item.userObjectId, canView: item.canView, canCreateModify: item.canCreateModify, canDelete: item.canDelete } })
                const list = [];
                this.shareablePersonListChanges.forEach(item => {
                    if (list.filter(x => x.userId === item.userObjectId).length < 1) {
                        list.push({ userId: item.userObjectId, canView: item.canView, canCreateModify: item.canCreateModify, canDelete: item.canDelete });
                    }
                });
                this.terminService.putShareOwnCalendar(list).then(() => {
                    this.shareablePersonListChanges = [];
                    this.getShareablePersonList();
                });
            }
        };
        TerminListController = __decorate([
            QMC.Controller('QMC.Termin', 'TerminListController'),
            QMC.Inject('TerminService', '$qui', 'FachleistungService', 'KlientService', '$state', '$scope', '$timeout', 'QmcLanguageService', 'UserService', '$location', 'QmcPermissionService', '$stateParams', 'AufgabenService', 'StammdatenService')
        ], TerminListController);
        Termin.TerminListController = TerminListController;
    })(Termin = QMC.Termin || (QMC.Termin = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Termin;
    (function (Termin) {
        let TerminDetailController = class TerminDetailController {
            /**
             * Creates an instance of TerminDetailController.
             * @param {TerminService} terminService
             * @param {any} $qui
             * @param {Fachleistung.FlsService} flsService
             * @param {any} $state
             * @param {any} $stateParams
             * @param {any} $scope
             * @param {Klient.KlientService} clientService
             * @param {Common.QmcLanguageService} lng
             *
             * @memberOf TerminDetailController
             */
            constructor(terminService, $qui, flsService, $state, $stateParams, $scope, $timeout, clientService, lng, permissionService) {
                var _a;
                this.terminService = terminService;
                this.$qui = $qui;
                this.flsService = flsService;
                this.$state = $state;
                this.$stateParams = $stateParams;
                this.$scope = $scope;
                this.$timeout = $timeout;
                this.clientService = clientService;
                this.lng = lng;
                this.permissionService = permissionService;
                this.ui = new Termin.UserInterface();
                this.calendarList = [];
                this.formState = 'new';
                this.appointmentTypesToShow = [
                    401000,
                    401010 // Fls
                ];
                this.promptOptions = {};
                this.reccuring = new Termin.RecurringOptions();
                this.permissions = {
                    delete: false,
                    modify: false,
                    new: true
                };
                this.loadingSemaphor = false;
                this.participants = [];
                this.loading = { participants: false, appointment: false, calendar: false };
                /**
                 * get list of specific reccuring types
                 *
                 * @private
                 *
                 * @memberOf TerminListController
                 */
                this.getRecurringTypes = () => { return this.reccuring.reccuringSelectList; };
                this.getReminderUnits = () => { return this.reminderUnits; };
                if (document.getElementById("permissions").getAttribute("appointment").toLocaleLowerCase() !== "true") {
                    console.log("No rights to see module appointment");
                    this.forbidden = true;
                    return;
                }
                const storageObject = QMC.Common.personalLocalStorage.getItem(QMC.Common.LocalStorageConstants.APPOINTMENT_TYPES_TO_SHOW);
                if (storageObject)
                    this.appointmentTypesToShow = (_a = storageObject === null || storageObject === void 0 ? void 0 : storageObject.split(",").map(Number)) !== null && _a !== void 0 ? _a : this.appointmentTypesToShow;
                this.initForm();
                this.getDetailData();
                this.reminderUnits = [
                    { value: 0, text: this.lng.translate(20000247, 'Minuten') },
                    { value: 1, text: this.lng.translate(20000219, 'Stunden') },
                    { value: 2, text: this.lng.translate(20000245, 'Tage') },
                    { value: 3, text: this.lng.translate(20000246, 'Monate') }
                ];
                flsService.getCasesList().then((data) => {
                    this.cases = data;
                    this.caseList = $qui.select(data, { value: 'internalName', text: 'internalName' });
                });
                this.$timeout = $timeout;
                this.promptOptionsAllParticipantsDelete = {
                    title: this.lng.translate(20018048, 'Wollen Sie den Termin wirklich löschen?'),
                    id: "prompt-delete",
                    icon: "qm-icon-calendar_7",
                    fields: [
                        {
                            text: this.lng.translate(20018043, 'Soll der Termin für alle Teilnehmer gelöscht werden?'), name: 'allParticipants',
                            options: [{ text: this.lng.translate(20018046, "Nur für mich"), value: false }, { text: this.lng.translate(20018047, "Für alle Teilnehmer"), value: true }]
                        }
                    ]
                };
                this.promptOptionsApointmentDelete = {
                    title: this.lng.translate(20018033, "Termin"),
                    icon: "qm-icon-calendar_7",
                    yesNo: true,
                    id: "prompt-single-delete",
                    text: this.lng.translate(20018048, 'Wollen Sie den Termin wirklich löschen?')
                };
                this.promptOptionsSingleUpdate = {
                    title: this.lng.translate(20018033, "Termin"),
                    icon: "qm-icon-calendar_7",
                    yesNo: true,
                    id: "prompt-single-update",
                    text: this.lng.translate(20018049, 'Wollen Sie den Termin wirklich bearbeiten?')
                };
                this.promptOptionsSeriesUpdate = {
                    title: this.lng.translate(20018050, "Serientermin"),
                    icon: "qm-icon-calendar_7",
                    id: "prompt-change",
                    fields: [
                        {
                            text: this.lng.translate(20018051, 'Wollen Sie diesen Termin oder die ganze Serie bearbeiten?'), name: 'wholeSeries',
                            options: [{ text: this.lng.translate(20018044, "Dieser Termin"), value: false }, { text: this.lng.translate(20018045, "Alle Termine dieser Serie"), value: true }]
                        }
                    ]
                };
                this.promptOptionsOnlySeriesUpdate = {
                    title: this.lng.translate(20018050, "Serientermin"),
                    icon: "qm-icon-calendar_7",
                    yesNo: true,
                    id: "prompt-single-update",
                    text: this.lng.translate(20018054, 'Wollen Sie die Terminserie wirklich bearbeiten?')
                };
                $qui.init($qui.getSectionColor('/appointment'), () => {
                    $qui.anonAvatar();
                    $qui.bindEvents();
                    $(".help-block").parent("div").attr("style", "");
                });
                this.$scope.$watch('vm.form.recuringType', () => {
                    var _a;
                    if (this.form.recuringType > 0 && this.form.recuringType !== null && this.form.disableRecurring === false) {
                        this.form.disableRecurringEndDate = false;
                        this.form.rangeDateFrom = this.form.dateFrom;
                        this.form.rangeDateTo = (_a = this.form.rangeDateTo) !== null && _a !== void 0 ? _a : this.oldRangeDateTo;
                        this.form.isRecurring = true;
                    }
                    else {
                        this.form.disableRecurringEndDate = true;
                        this.form.isRecurring = this.form.recuringType !== null && this.form.recuringType !== undefined;
                        this.form.rangeDateTo = this.form.isRecurring ? this.form.rangeDateTo : null;
                    }
                });
                this.loading.participants = true;
                this.clientService.getPersonListByObjectTypes([120000, 130000, 140000, 140006], '', true, false).then((data) => {
                    data.map(item => {
                        item.displayTitle = this.$qui.createPersonDisplay(item.displayTitle, '', item.shortCaption, item.personNumber);
                        return item;
                    });
                    this.clientService.getAllPersonLists().then((dataPL) => {
                        this.clientService.getResourceList('', true).then((dataRes) => {
                            this.clientService.getVehicleList().then((dataVeh) => {
                                let temp = data.map((x) => ({ text: x.displayTitle, value: x.objectId, group: this.getGroupName(x.objectType), subText: x.institute }));
                                temp = temp.concat(dataPL.map((x) => ({ text: x.name, value: x.objectId, group: this.lng.translate(20000237, 'Personenliste'), subText: '' })));
                                temp = temp.concat(dataRes.map((x) => ({ text: x.caption, value: x.objectId, group: this.lng.translate(20000271, 'Ressource'), subText: x.institute })));
                                temp = temp.concat(dataVeh.map((x) => ({ text: x.displayTitle, value: x.objectId, group: this.lng.translate(20029006, 'Fuhrpark'), subText: x.kindOfVehicle })));
                                temp.sort((a, b) => (a.text.toLocaleLowerCase() > b.text.toLocaleLowerCase()) ? 1 : ((b.text.toLocaleLowerCase() > a.text.toLocaleLowerCase()) ? -1 : 0));
                                temp.sort((a, b) => (a.group.toLocaleLowerCase() > b.group.toLocaleLowerCase()) ? 1 : ((b.group.toLocaleLowerCase() > a.group.toLocaleLowerCase()) ? -1 : 0));
                                this.participants = temp;
                                this.loading.participants = false;
                            });
                        });
                    });
                });
            }
            getParticipants() {
                return this.participants;
            }
            getGroupName(type) {
                switch (type) {
                    case 120000:
                        return this.lng.translate(20000235, 'Mitarbeiter');
                    case 130000:
                        return this.lng.translate(20000279, 'Organisation');
                    case 140000:
                        return this.lng.translate(21002000, 'Klient');
                    case 140006:
                        return this.lng.translate(20001048, 'Kontaktperson');
                    default:
                        return '';
                }
            }
            /**
             * convert a string to title case
             *
             * @private
             * @param {string} str
             * @returns {string}
             *
             * @memberOf TerminDetailController
             */
            toTitleCase(str) {
                return str.replace(/\w\S*/g, txt => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase());
            }
            /**
             * init the form with default values
             *
             * @private
             *
             * @memberOf TerminDetailController
             */
            initForm() {
                this.form = {
                    title: null,
                    dateFrom: null,
                    dateTo: null,
                    isAllDay: true,
                    location: null,
                    participantIds: [],
                    description: null,
                    isFinished: false,
                    isPrivate: false,
                    rangeDateFrom: null,
                    rangeDateTo: null,
                    recuringType: 0,
                    disableRecurring: false,
                    disableRecurringEndDate: false,
                    recurrenceChangeDateFrom: null,
                    recurrenceChangeDateTo: null,
                    recurrenceData: null
                };
            }
            toogleBackButton() {
                this.$qui.waitForEl('#edit-form-detail', () => {
                    $('#edit-form-detail').on('hidden.bs.modal', () => {
                        for (const element of this.$state.history) {
                            //in order to avoid getting the <</appointment/:id/:isRecurring/:participantId/:dateFrom/:start/:end>> also check if url is the basic home appointment url
                            if ((element.name === 'appointment') && (element.url === '/appointment?:startDay?view')) {
                                this.$state.go(element.name, element.params);
                                let url = $("#session").data().baseUrl + element.url;
                                history.replaceState({ backButtonPresse: false }, '', url.replace('//', '/'));
                                break;
                            }
                        }
                    });
                });
            }
            /**
             * put an existing appointment
             *
             * @private
             * @param {any} form is modified IAppointmentUpdate, to inject participants
             *
             * @memberOf TerminListController
             */
            putAppointment(form) {
                this.validateAppointment(form);
                this.validationCallback = () => {
                    $('#edit-form-detail').modal('hide');
                    this.sendPut(form);
                };
            }
            sendPut(form) {
                var _a;
                this.loading.appointment = true;
                if (form.isRecurring) {
                    form.recurrenceOptions = this.reccuring.getOptions(Number(form.recuringType), form.dateFrom);
                    if (form.recuringType > 0) {
                        form.isRecurring = true;
                        if (form.recurrenceOptions === null)
                            form.isRecurring = false;
                        form.recurrenceOptions.rangeDateFrom = (_a = form.rangeDateFrom) !== null && _a !== void 0 ? _a : form.dateFrom;
                        form.recurrenceOptions.rangeDateTo = form.rangeDateTo;
                        this.reccuring.setRangeLimit(0);
                        if (form.recuringType > 0) {
                            this.reccuring.setRangeLimit(2);
                        }
                        //when the appointment is edited as a whole, do not forget to set the dateFrom and dateTo with the rageDateFrom
                        if (this.$stateParams.wholeSerie === "true") {
                            form.dateTo.setDate(form.dateFrom.getDate());
                            form.dateTo.setMonth(form.dateFrom.getMonth());
                            form.dateTo.setFullYear(form.dateFrom.getFullYear());
                            form.recurrenceOptions.rangeDateFrom = form.dateFrom;
                            form.rangeDateFrom = form.dateFrom;
                        }
                        form.recurrenceOptions = this.reccuring.getOptions(Number(form.recuringType), form.rangeDateFrom);
                    }
                }
                else {
                    form.recurrenceOptions = null;
                    form.recurrenceSettings = null;
                }
                this.terminService.putAppointment((form.isRecurring && form.recuringType > 0) ? form.mainAppointmentId : form.id, (form.isRecurring && form.recuringType > 0), this.selectedCalendar, form.isRecurring && form.recuringType > 0 ? form.rangeDateFrom : form.dateFrom, !!(form.isRecurring && form.recurrenceOptions != null && !form.disableRecurring), form).then(() => {
                    this.ui.notify(this.ui.successNote);
                    this.formState = "new";
                }).finally(() => {
                    this.loading.appointment = true;
                    location.hash = "#/appointment";
                });
            }
            /**
             * remove a appointment
             *
             * @private
             * @param {IAppointment} form
             *
             * @memberOf TerminListController
             */
            deleteAppointment(form) {
                $('#edit-form-detail').unbind('hidden.bs.modal');
                $('#edit-form-detail').modal('toggle');
                //if one participant, do not show the prompt for asking user to delete for him or for all participants
                this.promptOptions = form.participantIds.length > 1 ? this.promptOptionsAllParticipantsDelete : this.promptOptionsApointmentDelete;
                QMC.Common.Utilities.confirm(this.promptOptions, (data) => {
                    if (data) {
                        this.terminService.deleteAppointment(form.isRecurring ? form.mainAppointmentId : form.id, form.isRecurring, this.selectedCalendar, form.isRecurring ? form.rangeDateFrom : form.dateFrom, this.$stateParams.wholeSerie === "true" ? 1 : 0, form.participantIds.length > 1 ? data.allParticipants : false).then(() => {
                            this.ui.notify(this.ui.deleteNote, this.lng.translate(20018032, "Termin gelöscht"));
                            this.formState = 'new';
                            location.hash = "#/appointment";
                        });
                    }
                    else {
                        location.hash = '#/appointment';
                    }
                });
            }
            /**
             * get the detail data by id
             *
             * @private
             *
             * @memberOf TerminDetailController
             */
            getDetailData() {
                this.loading.appointment = true;
                this.permissions = {
                    new: true,
                    modify: false,
                    delete: false,
                };
                setTimeout(() => this.$qui.waitForEl('#edit-form-detail', () => $('#edit-form-detail').modal('show')));
                this.terminService.getAppointment(this.$stateParams.id, this.$stateParams.participantId, this.$stateParams.dateFrom, this.$stateParams.wholeSerie, this.$stateParams.permFlag).then((data) => {
                    this.permissions.delete = data.permissions.delete;
                    this.permissions.new = data.permissions.new;
                    this.permissions.modify = data.permissions.modify;
                    this.selectedCalendar = this.$stateParams.participantId;
                    this.form = data;
                    this.form.disableRecurring = this.$stateParams.wholeSerie !== "true" && data.isRecurring;
                    this.formState = 'edit';
                    if (this.form.recurrenceOptions !== null) {
                        this.form.recuringType = this.reccuring.setInputField(this.form.recurrenceOptions);
                        this.oldRecurringType = this.form.recuringType;
                    }
                    this.form.dateFrom = this.$qui.createDateFromString(!data.isRecurring || this.$stateParams.start == 0 || this.$stateParams.wholeSerie === "true" ? data.dateFrom : this.$stateParams.start);
                    this.form.dateTo = this.$qui.createDateFromString(!data.isRecurring || this.$stateParams.end == 0 || this.$stateParams.wholeSerie === "true" ? data.dateTo : this.$stateParams.end);
                    if (data.isRecurring) {
                        this.form.rangeDateTo = data.recurrenceOptions.rangeDateTo != null ?
                            this.$qui.createDateFromString(data.recurrenceOptions.rangeDateTo) : null;
                        this.form.rangeDateFrom = data.recurrenceOptions.rangeDateFrom != null ?
                            this.$qui.createDateFromString(data.recurrenceOptions.rangeDateFrom) :
                            this.$qui.createDateFromString(this.form.dateFrom);
                        this.form.rangeDateFrom.setTime(this.form.dateFrom.getTime());
                        this.oldRangeDateTo = this.form.rangeDateTo;
                    }
                    else {
                        this.form.disableRecurringEndDate = false;
                        this.form.rangeDateFrom = this.$qui.createDateFromString(this.form.dateFrom);
                        this.form.rangeDateTo = this.form.dateTo;
                        this.form.isRecurring = false;
                    }
                    this.form.recurrenceChangeDateFrom = data.isRecurring ? this.form.rangeDateFrom : this.form.dateFrom;
                    this.form.recurrenceChangeDateTo = data.isRecurring ? this.form.rangeDateTo : this.form.dateTo;
                    this.form.recurringType = this.reccuring.setInputField(data.recurrenceOptions);
                    this.waitToCreateForm();
                    this.toogleBackButton();
                }).finally(() => this.loading.appointment = false);
            }
            waitToCreateForm() {
                if (!this.loading.appointment && !this.loading.participants) {
                    this.$timeout(() => {
                        this.$qui.functionWaiter("ui.createDetailForm", this);
                        this.$qui.scopeApply(this.$scope);
                    });
                }
                else {
                    setTimeout(() => {
                        this.waitToCreateForm();
                    }, 250);
                }
            }
            /**
             * Returns a qmc calendar event which can be shown in the calendar
             * @param appointment The appointment object
             */
            createCalendarEvent(appointment) {
                const event = {};
                event.id = appointment.objectId;
                event.objectId = appointment.objectId;
                event.mid = appointment.mainAppointmentId;
                event.title = appointment.title;
                event.start = moment(appointment.dateFrom);
                event.end = moment(appointment.dateTo);
                event.allDay = appointment.isAllDay;
                event.isFinished = appointment.isFinished;
                event.isPrivate = appointment.isPrivate;
                event.isRecurring = appointment.isRecurring;
                event.isTypeAppointment = appointment.isTypeAppointment;
                event.editable = true;
                event.color = appointment.colorHtml;
                event.iconCode = "";
                if (event.isFinished) {
                    event.iconCode += "<i class='fa fa-check'></i> ";
                }
                if (event.isPrivate) {
                    event.iconCode += "<i class='fa fa-lock'></i> ";
                }
                if (event.isRecurring) {
                    event.iconCode += "<i class='fa fa-refresh'></i> ";
                    event.editable = false;
                }
                if (event.isDeleted) {
                    event.iconCode += "<i class='fa fa-trash'></i> ";
                }
                if (!event.isTypeAppointment) {
                    event.editable = false;
                }
                return event;
            }
        };
        TerminDetailController = __decorate([
            QMC.Controller('QMC.Termin', 'TerminDetailController'),
            QMC.Inject('TerminService', '$qui', 'FachleistungService', '$state', '$stateParams', '$scope', '$timeout', 'KlientService', 'QmcLanguageService', 'QmcPermissionService')
        ], TerminDetailController);
    })(Termin = QMC.Termin || (QMC.Termin = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Termin;
    (function (Termin) {
        class RecurringOptions {
            constructor() {
                this.reccuringSelectList = [];
                this.reccuringTypes = ['Niemals', 'Täglich', 'Wöchentlich', 'Alle 2 Wochen', 'Monatlich', 'Jährlich'];
                this.getInfragisticsWeekday = (date) => {
                    switch (date.getDay()) {
                        case 0:
                            return 1;
                        case 1:
                            return 2;
                        case 2:
                            return 4;
                        case 3:
                            return 8;
                        case 4:
                            return 16;
                        case 5:
                            return 32;
                        case 6:
                            return 64;
                        default:
                            return 1;
                    }
                };
                this.options = {
                    "frequency": 1,
                    "rangeLimit": 0,
                    "rangeMaxOcurrences": 0,
                    "rangeDateFrom": "2017-05-02T08:33:03.820Z",
                    "rangeDateTo": "2030-05-02T08:33:03.820Z",
                    "occurence": 0,
                    "interval": 1,
                    "dayOfMonth": 0,
                    "monthOfYear": 0,
                    "daysOfWeek": [0]
                };
                this.options.rangeDateFrom = new Date();
                this.setOptionList();
            }
            setOptionList() {
                var optionWrap = (val) => {
                    this.reccuringSelectList.push({
                        value: this.reccuringSelectList.length,
                        text: val,
                        isFix: this.reccuringSelectList.length < 1
                    });
                };
                for (var recType in this.reccuringTypes)
                    optionWrap(this.reccuringTypes[recType]);
                setTimeout(() => { $("#recuringType").val(0); }, 950);
            }
            setInputField(options) {
                console.log("options", options);
                if (options == null)
                    return 0;
                if (options.frequency === 0)
                    return 1;
                if (options.frequency === 1) {
                    if (options.interval === 1)
                        return 2;
                    if (options.interval === 2)
                        return 3;
                }
                if (options.frequency === 2)
                    return 4;
                if (options.frequency === 3)
                    return 5;
                return 0;
            }
            getOptions(type, date) {
                if (type < 0)
                    return null;
                switch (type) {
                    case 0:
                        return null;
                    case 1:
                        this.options.frequency = 0;
                        this.options.interval = 1;
                        this.options.daysOfWeek = [127];
                        break;
                    case 2:
                        this.options.frequency = 1;
                        this.options.interval = 1;
                        this.options.daysOfWeek = [];
                        this.options.daysOfWeek.push(this.getInfragisticsWeekday(date));
                        break;
                    case 3:
                        this.options.frequency = 1;
                        this.options.interval = 2;
                        this.options.daysOfWeek = [];
                        this.options.daysOfWeek.push(this.getInfragisticsWeekday(date));
                        break;
                    case 4:
                        this.options.frequency = 2;
                        this.options.interval = 1;
                        this.options.dayOfMonth = date.getDate();
                        break;
                    case 5:
                        this.options.frequency = 3;
                        this.options.interval = 1;
                        this.options.dayOfMonth = date.getDate();
                        this.options.monthOfYear = date.getMonth() + 1;
                        break;
                }
                return this.options;
            }
            setRangeLimit(limit) {
                this.options.rangeLimit = limit;
            }
        }
        Termin.RecurringOptions = RecurringOptions;
    })(Termin = QMC.Termin || (QMC.Termin = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Termin;
    (function (Termin) {
        let TerminDirective = class TerminDirective {
            constructor() {
                this.restrict = 'E';
                this.templateUrl = './Termin/Widget';
                this.replace = true;
                this.scope = {};
                this.controllerAs = 'vm';
                this.controller = 'TerminListController';
                this.bindToController = true;
                this.link = (scope, element, attrs, ctrl) => {
                    ctrl.isWidget = true;
                    ctrl.calendarName = 'widgetCalendar';
                    scope.dateNow = Date.now();
                    scope.forbidden = false;
                    scope.openNewModal = () => {
                        ctrl.initForm();
                        $('#edit-form').modal('toggle');
                    };
                    ctrl.setupCalendar = function () {
                        var _a;
                        const allDayText = this.lng.translate(20018016, "Ganztägig");
                        const viewStart = moment(ctrl.viewDateFrom).startOf('day');
                        const viewEnd = moment(ctrl.viewDateTo).startOf('day');
                        const durationDays = Math.max(1, viewEnd.diff(viewStart, 'days') + 1);
                        //var newDateText = this.lng.translate(20018040, "Neuer Termin");
                        $(`#${ctrl.calendarName}`).fullCalendar({
                            schedulerLicenseKey: QMC.Common.Constants.FULL_CALENDAR_PREMIUM_LICENSE,
                            defaultView: 'listWidget',
                            defaultDate: viewStart.toDate(),
                            allDayText: allDayText,
                            monthNames: this.lng.translate(20018519, 'Januar,Februar,März,April,Mai,Juni,Juli,August,September,Oktober,November,Dezember').split(','),
                            monthNamesShort: this.lng.translate(20018520, 'Jan,Feb,Mrz,Apr,Mai,Jun,Jul,Aug,Sep,Okt,Nov,Dez').split(','),
                            dayNames: this.lng.translate(20018521, 'Sonntag,Montag,Dienstag,Mittwoch,Donnerstag,Freitag,Samstag').split(','),
                            dayNamesShort: this.lng.translate(20018522, 'So.,Mo.,Di.,Mi.,Do.,Fr.,Sa.').split(','),
                            timezone: "local",
                            nowIndicator: true,
                            events: (_a = scope.qmData) !== null && _a !== void 0 ? _a : [],
                            height: 'auto',
                            firstDay: 1,
                            scrollTime: moment(new Date()).format("HH:mm:ss"),
                            titleFormat: '[Termine]',
                            eventDurationEditable: false,
                            eventStartEditable: false,
                            noEventsMessage: this.lng.translate(20018529, 'keine kommenden Termine in dieser Woche'),
                            views: {
                                listWidget: {
                                    type: 'list',
                                    duration: { days: durationDays }
                                },
                                day: {
                                    titleFormat: 'dddd D.MM'
                                }
                            },
                            header: {
                                left: '',
                                center: '',
                                right: ''
                            },
                            //customButtons: {
                            //    addBtn: {
                            //        text: newDateText,
                            //        click: function () {
                            //            $('#edit-form-detail').modal('toggle');
                            //        }
                            //    }
                            //},
                            eventRender: (event, element) => {
                                element.find(".fc-list-item-title").prepend(event.iconCode);
                            },
                            eventAfterAllRender: () => {
                                this.ui.formatListDates();
                            },
                            eventClick: (event) => {
                                if (event.end === undefined || event.end === null)
                                    event.end = event.start;
                                $(`#${ctrl.calendarName}`).fullCalendar('removeEvents');
                                location.hash = location.hash = this.ui.detailLink(event, event.isRecurring);
                            },
                        });
                    };
                    ctrl.widgetRender = function (calEvents) {
                        scope.qmData = calEvents;
                        if (calEvents && calEvents.length >= 1) {
                            ctrl.setupCalendar();
                            setTimeout(function () {
                                $(`#${ctrl.calendarName}`).fullCalendar('render');
                            }, 500);
                        }
                    };
                };
            }
        };
        TerminDirective = __decorate([
            QMC.Directive('QMC.Termin', 'qmAppointmentWidget', [])
        ], TerminDirective);
    })(Termin = QMC.Termin || (QMC.Termin = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Termin;
    (function (Termin) {
        let TerminValidationDirective = class TerminValidationDirective {
            constructor(appointmentService, lng) {
                this.appointmentService = appointmentService;
                this.lng = lng;
                this.restrict = 'EA';
                this.templateUrl = './Termin/Validation';
                this.replace = true;
                this.scope = {
                    callback: '&',
                    validate: '='
                };
                this.link = (scope) => {
                    let formStore;
                    scope.id = 'appointmentValidationModal_' + Math.random().toString(36).substr(2, 9);
                    scope.validationResult = {
                        '': {
                            warnings: [],
                            errors: [this.lng.translate(20000328, 'Es konnte keine Validierung durchgeführt werden')]
                        }
                    };
                    scope.validate = (form) => {
                        formStore = form;
                        $(`#appointmentValidationModal_${scope.id}`).modal('show');
                        scope.loading = true;
                        this.appointmentService.validateAppointment({
                            dateFrom: form.dateFrom,
                            dateTo: form.dateTo,
                            attendeeIds: form.participantIds,
                            mainAppointmentId: form.mainAppointmentId
                        }).then(data => {
                            scope.validationResult = data;
                            if (scope.noErrors() && scope.noWarnings())
                                scope.save();
                        }).catch(() => {
                            scope.validationResult = {
                                '': {
                                    warnings: [],
                                    errors: [this.lng.translate(20000328, 'Es konnte keine Validierung durchgeführt werden')]
                                }
                            };
                        }).finally(() => scope.loading = false);
                    };
                    scope.noErrors = () => {
                        if (!scope.validationResult)
                            return false;
                        for (const attendee in scope.validationResult) {
                            if (scope.validationResult[attendee].errors.length)
                                return false;
                        }
                        return true;
                    };
                    scope.noWarnings = () => {
                        if (!scope.validationResult)
                            return false;
                        for (const attendee in scope.validationResult) {
                            if (scope.validationResult[attendee].warnings.length)
                                return false;
                        }
                        return true;
                    };
                    scope.save = () => {
                        $(`#appointmentValidationModal_${scope.id}`).modal('hide');
                        scope.callback()(formStore);
                    };
                };
            }
        };
        TerminValidationDirective = __decorate([
            QMC.Directive('QMC.Termin', 'qmAppointmentValidation', ['TerminService', 'QmcLanguageService'])
        ], TerminValidationDirective);
    })(Termin = QMC.Termin || (QMC.Termin = {}));
})(QMC || (QMC = {}));

//# sourceMappingURL=../../maps/Termin/qmc.termin.js.map
